
import { ReactNode, createContext, useContext, useEffect, useState } from "react";
import { useQuery } from "react-query";
import axiosClient from "../lib/axios";
import { AuthContext } from "./AuthContext";
import { usePermissionsContext } from "./PermissionsContext";

export interface NotificacoesContextType {
    quantidadeTarefas: number;
    refresh: () => void;
}

export const NotificacoesContext = createContext<NotificacoesContextType>({
    quantidadeTarefas: 0,
    refresh: () => { }
});

export function NotificacoesProvider({ children }: { children: ReactNode }) {

    const { isAuth, token } = useContext(AuthContext);
    const { permissoes } = usePermissionsContext();

    const { data: contarTarefas, refetch } = useQuery({
        queryKey: 'conta-tarefas',
        queryFn: () => axiosClient.get("/contar-tarefas"),
        enabled: isAuth,
        cacheTime: 0
    })

    const quantidadeTarefas = contarTarefas?.data?.quantidade || 0;

    const refresh = () => {
        refetch();
    }

    useEffect(() => {
        if (token) refetch()
    }, [token, permissoes])

    return (
        <NotificacoesContext.Provider value={{ quantidadeTarefas, refresh }}>
            {children}
        </NotificacoesContext.Provider>
    )
}